const selectors = {
	container: '[js-featured-products="container"]'
}

document.addEventListener('DOMContentLoaded', () => {
	const node_selectors = {
		container: document.querySelector(selectors.container),
	}

	function initSlider() {
		if (!node_selectors.container) { return; }
		const swiper = new Swiper(selectors.container, {
			loop: true,
			slidesPerView: 2,
			spaceBetween: 10,
			centeredSlides: true,
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 40,
				}
			}
		});
	}

	initSlider();
});